module.exports = __webpack_public_path__ + "static/media/icon_compare_celebrity_active.f5f02229.svg";